import script from "./BrockerPurchaseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BrockerPurchaseForm.vue?vue&type=script&setup=true&lang=js"

import "./BrockerPurchaseForm.vue?vue&type=style&index=0&id=946c7968&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-946c7968"]])

export default __exports__